/**
 * SortableTabs hook — drag-to-reorder tabs.
 * Sends "reorder_tabs" event with new order of file IDs.
 */
export default {
  mounted() {
    this._setupDrag()
  },

  updated() {
    this._setupDrag()
  },

  _setupDrag() {
    const container = this.el
    let dragEl = null

    container.querySelectorAll("[data-tab-id]").forEach(tab => {
      tab.setAttribute("draggable", "true")

      tab.ondragstart = (e) => {
        dragEl = tab
        tab.style.opacity = "0.4"
        e.dataTransfer.effectAllowed = "move"
        e.dataTransfer.setData("text/plain", tab.dataset.tabId)
      }

      tab.ondragend = () => {
        tab.style.opacity = ""
        dragEl = null
        container.querySelectorAll("[data-tab-id]").forEach(t => t.classList.remove("border-l-2", "border-l-[var(--accent-primary)]"))
      }

      tab.ondragover = (e) => {
        e.preventDefault()
        e.dataTransfer.dropEffect = "move"
        if (tab !== dragEl) {
          tab.classList.add("border-l-2", "border-l-[var(--accent-primary)]")
        }
      }

      tab.ondragleave = () => {
        tab.classList.remove("border-l-2", "border-l-[var(--accent-primary)]")
      }

      tab.ondrop = (e) => {
        e.preventDefault()
        tab.classList.remove("border-l-2", "border-l-[var(--accent-primary)]")
        if (!dragEl || dragEl === tab) return

        // Reorder in DOM
        const tabs = [...container.querySelectorAll("[data-tab-id]")]
        const fromIdx = tabs.indexOf(dragEl)
        const toIdx = tabs.indexOf(tab)
        if (fromIdx < toIdx) {
          tab.after(dragEl)
        } else {
          tab.before(dragEl)
        }

        // Send new order to server
        const newOrder = [...container.querySelectorAll("[data-tab-id]")].map(t => t.dataset.tabId)
        this.pushEvent("reorder_tabs", { order: newOrder })
      }
    })
  }
}
